<script setup lang="ts">
const props = defineProps<{
  nextItemDelayMS: number;
  carroussel: Record<
    string,
    {
      image: string;
      text: string;
    }
  >;
  themeKeys: {
    bg: string;
    fg: string;
    unselectedBg: string;
    selectedBg: string;
    selectedFg: string;
  };
}>();

const selectedIndex = ref(0);
const moveIndex = (qt) => {
  selectedIndex.value =
    (selectedIndex.value + qt) % Object.keys(props.carroussel).length;
};

const unselectedStyle = computed(() => ({
  color: props.themeKeys.fg,
  backgroundColor: props.themeKeys.unselectedBg,
}));
const selectedStyle = computed(() => ({
  backgroundColor: props.themeKeys.selectedBg,
  color: props.themeKeys.selectedFg,
}));

const unselectedImageStyle = computed(() => ({
  opacity: 0,
  transform: 'scale(98%)',
}));
const selectedImageStyle = computed(() => ({
  opacity: 1,
  transform: 'scale(100%)',
}));

onMounted(() => {
  setInterval(() => {
    moveIndex(1);
  }, props.nextItemDelayMS);
});
</script>

<template>
  <div
    class="outer-p-container transition duration-500"
    :style="{
      backgroundColor: props.themeKeys.bg,
      color: props.themeKeys.fg,
    }"
  >
    <div class="inner-container">
      <div class="flex flex-col md:flex-row items-start justify-between gap-8">
        <div class="md:w-1/2">
          <div class="h-full w-full relative">
            <NuxtImg
              v-for="(item, index) in Object.values(props.carroussel)"
              :src="item.image"
              role="presentation"
              class="absolute top-0 h-96 w-full object-cover aspect-video transition-all duration-300"
              :style="index === selectedIndex ? selectedImageStyle : unselectedImageStyle"
            />
          </div>
        </div>
        <div class="w-full md:w-2/5 flex gap-4 flex-row flex-wrap md:flex-col items-center md:items-start md:justify-between" >
          <div
            v-for="(item, index) in Object.values(props.carroussel)"
            class="md:w-full"
          >
            <button
              class="md:w-full hover:shadow-lg transition text-left p-4 rounded-lg"
              :style="index === selectedIndex ? selectedStyle : unselectedStyle"
              @click="selectedIndex = index"
            >
              {{ item.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
